import "../../components/ProfileCard/ProfileCard.scss";
import "./PersonalBonus.scss";
import LevelProfile from "./components/LevelProfile/LevelProfile";
import ProgressLevel from "./components/ProgressLevel/ProgressLevel";
import Bonus from "./components/Bonus/Bonus";
import {useUserStore} from "../../../../../modules/shop/user/store";
import {MAX_LEVEL} from "./components/LevelBlock/LevelBlock";

// Особистий бонус: кільце з поточним бонусом у головній картці, нижче рівні й прогрес, підказка про правило
const PersonalBonus = () => {
    const user = useUserStore(state => state.user)
    // на максимальному рівні вся сторінка переходить у золото
    const maxed = (Number(user?.personalBonus) || 0) >= MAX_LEVEL

    return (
        <div className={`bc-page ${maxed ? "pb-max" : ""}`}>
            <div className="bc-card pb-hero">
                <Bonus user={user} />
                <h3 className="bc-title">Особистий бонус</h3>
                <p className="bc-text">Цей відсоток додається до кожного поповнення балансу. Що більше ви поповнюєте — то вищий рівень і бонус.</p>
            </div>

            <div className="bc-list-card pb-main">
                <LevelProfile user={user} />
                <ProgressLevel user={user} />
            </div>

            <div className="bc-hint">
                <div>
                    <b>Як росте бонус?</b>
                    <span>Кожні 2500 ₴ поповнень відкривають новий рівень і +1% до бонусу — максимум +5%.</span>
                </div>
            </div>
        </div>
    );
};

export default PersonalBonus;
